import React, {useEffect, useState} from 'react';
import UserMenu from './UserMenu/UserMenu';
import Alert from '@material-ui/lab/Alert';

const Header = ({user, selectedLanguage, handleLangSwitch, switchLoggedInState, loginError}) => {
    const [isProd, setIsProd] = useState(false);
    useEffect(() => {
        if (window.location.origin.includes('staging') || window.location.origin.includes('test')
            || window.location.origin.includes('localhost')) {
            setIsProd(false);
        } else {
            setIsProd(true);
        }
    }, []);

    return (
        <div className="header">
            <div className="flex flex-col items-center gap-1 mt-2">
                <img alt="Main Logo" src="/AddAI_logo1.png" width={50} className="p-1"/>
                {isProd &&
                    <span className="text-yellow-500 text-white text-xs">PROD</span>
                }
            </div>
            <div className="flex gap-2 items-center flex-col mt-auto mb-4">
                <UserMenu
                    user={user}
                    selectedLanguage={selectedLanguage}
                    handleLangSwitch={handleLangSwitch}
                    switchLoggedInState={switchLoggedInState}
                />
            </div>
            {loginError.length > 0 && (
                <Alert className="absolute top-4 left-80" severity="error">{loginError}</Alert>
            )}
        </div>
    );
};

export default Header;